// getPopupNotifications.js
'use strict';
import { createSelector } from '../resource/createCachedSelector.js';

import getListData from '../selector/getListData.js';
import getOperationData from '../selector/getOperationData.js';
import getIsValidPopupNotification from '../selector/getIsValidPopupNotification.js';
import {
  LIST_SELECT_PATH_PREFIX,
  DETAIL_SELECT_PATH_PREFIX,
} from '../resource/popupNotificationConstants.js';

const defaultList = [];

/**
 * Select popup notifications by list
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @return {array} return notification list with detail.
 */
const getPopupNotifications = createSelector(
  state =>
    (getListData(state, LIST_SELECT_PATH_PREFIX, 'itemIds') || defaultList)
      .filter(id => getIsValidPopupNotification(state, id))
      .map(id => {
        const notification = getOperationData(
          state,
          DETAIL_SELECT_PATH_PREFIX,
          id
        );
        const oembed = getOperationData(state, ['oembed'], notification?.link);
        return Object.assign({}, notification, { oembed });
      }),
  (notifications = defaultList) => notifications
);

export default getPopupNotifications;
